module.exports = __webpack_public_path__ + "static/media/SingleLayer-beam-oakley.7b73ebdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/SingleLayer-beam-oakley.png
// module id = 3429
// module chunks = 0